export default __webpack_public_path__ + "static/media/imagealttext.07e66456.svg";